import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Step } from '@platform/base';
const { Steps } = Step;
import "./index.less";
import CompMeta from '../../meta/LowCodeComponents/Steps';
const directionEnum = ["horizontal", "vertical"];
/**
 * @class NCSteps
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCSteps
 * @label 步骤条
 *
 */
class NCSteps extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 组件标识
         */
         moduleId: PropTypes.string.isRequired,
        /**
         * @title 设置当前步骤
         * @description 设置当前步骤
         */
        current: PropTypes.number,
        /**
         * @title step bar的大小
         * @description step bar的大小
         */
        size: PropTypes.string,
        /**
         * @title 方向
         * @description 方向
         *  @enumNames ['水平', '垂直']
         */
        direction: PropTypes.oneOf(directionEnum)
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        current: 0
    }

    render() {
        return (
            <div className="steps-wrapper">
                <Steps {...this.props} >{this.props.children}</Steps>
            </div>
        )
    }
}

export default NCSteps;
